import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Desplazamiento centralizado al cambiar de ruta.
 *
 * - Navegación nueva (PUSH / REPLACE): la pantalla destino abre desde arriba.
 * - Navegación hacia atrás (POP · botón Atrás del navegador o "Regresar" con
 *   history.back): NO forzamos el scroll para que el navegador restaure la
 *   posición previa de la lista (p.ej. volver a Mis Boletos donde estaba).
 *
 * Se monta una sola vez dentro del Router y evita llamadas dispersas a
 * `window.scrollTo` por pantalla.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType === "POP") return; // restaurar posición previa
    // Sube el scroll de la ventana (el shell del socio usa scroll de página).
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    // Además, por si alguna pantalla usa un contenedor con scroll propio.
    const main = document.querySelector("main");
    if (main && typeof main.scrollTo === "function") {
      main.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, [pathname, navType]);

  return null;
}
